import {
  CATEGORIAS_MONOTRIBUTO,
  type CategoriaMonotributo,
} from '../core/components/calendario/mensajeRecategorizacion'

/**
 * ORR-233 — Extrae la letra de categoría de monotributo de lo que devuelve el padrón AFIP.
 *
 * El padrón no garantiza formato: `determinarCondicionIVA` (afip-helpers.ts) toma
 * `descripcionCategoria || idCategoria`, y el primero es texto descriptivo. Así llegan
 * tanto `"D"` como `"Categoría D"` o `"D - Locaciones de servicios"`.
 *
 * Por qué no alcanza `charAt(0)`, que es lo que había: sobre `"Categoría D"` devuelve
 * `"C"` — una categoría **válida y equivocada**, que se escribiría sin que nada falle.
 * Un monotributista D pasaría a figurar como C, y con eso se le calcula la cuota.
 *
 * Devuelve `null` cuando no hay una letra A–K inequívoca. Descartar es la respuesta
 * correcta: el llamador omite el campo y deja intacto lo cargado.
 */
export function normalizarCategoriaMonotributo(crudo: string | null | undefined): CategoriaMonotributo | null {
  if (!crudo) return null

  // Los acentos hay que sacarlos ANTES de buscar, no por prolijidad: `\b` se apoya en
  // `\w`, que no incluye "Í", así que en "CATEGORÍA D" la "A" que sigue al acento queda
  // rodeada de no-palabra y matchea como letra aislada. Devolvía "A" para una D.
  const texto = crudo
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')

  // Una letra aislada, en cualquier posición: matchea la "D" de "CATEGORIA D" y la de
  // "D - LOCACIONES", pero no la "C" de "CATEGORIA", que no está aislada.
  const match = texto.match(/\b([A-K])\b/)
  if (!match) return null

  const letra = match[1] as CategoriaMonotributo
  return CATEGORIAS_MONOTRIBUTO.includes(letra) ? letra : null
}
